import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { Router } from '@angular/router';

@Component({
    selector: 'app-change-pw',
    templateUrl: './change-pw.component.html',
    styleUrls: ['./change-pw.component.scss'],
})
export class ChangePwComponent implements OnInit {
    public frm!: FormGroup;
    public loading = false;

    hidePasswordOLD = true; // Показывать пароль старый
    hidePasswordNEW = true; // Показывать пароль новый
    hidePasswordNEW2 = true; // Показывать пароль новый2
    exitForm = false; // Форма выхода

    constructor(
        public dialogRef: MatDialogRef<ChangePwComponent>,
        private auth: AuthService,
        private alertService: AlertService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.dialogRef.disableClose = true; // запрет закрытия окна (только командами)
    }

    ngOnInit(): void {
        this.initialize();
    }

    /* Инициализация при создании компанента */
    private initialize(): void {
        this.frm = new FormGroup({
            oldPW: new FormControl('', [
                Validators.required,
                Validators.minLength(3),
            ]),
            newPW: new FormControl('', [
                Validators.required,
                Validators.minLength(3),
            ]),
            new2PW: new FormControl('', [
                Validators.required,
                Validators.minLength(3),
            ]),
        });
        this.exitForm = false;
    }

    /* Проверка возможности отправки */
    testChangePW(): boolean {
        let f = false;
        let newPW = this.frm.get('newPW');
        let newPW2 = this.frm.get('new2PW');
        /*
    if (newPW && newPW2){
      
    }
*/
        if (this.loading == false) {
            if (this.frm.valid == true) {
                if (newPW && newPW2) {
                    if (newPW.value == newPW2.value) {
                        f = true;
                    }
                }
            }
        }
        return f;
    }

    exit() {
        this.auth.logout();
        this.dialogRef.close();
    }

    goToChange() {
        this.loading = true;
        let oldPW = this.frm.get('oldPW')?.value;
        let newPW = this.frm.get('newPW')?.value;

        if (oldPW === newPW) {
            this.alertService.error(
                'Новый пароль должен отличаться от предыдущего!',
                5000
            );
            this.loading = false;
            return;
        }

        if (oldPW && newPW) {
            this.auth.changepw(oldPW, newPW).subscribe(
                (info) => {
                    this.loading = false;
                    if (!info)
                        this.alertService.error(
                            'Неверно указан действующий пароль.'
                        );

                    if (info.err_text) this.alertService.error(info.err_text);

                    if (info.err_code === 0) {
                        this.exitForm = true;
                        this.alertService.info(
                            'Пароль успешно изменен. Пожалуйста, авторизуйтесь с новым паролем.',
                            6000
                        );
                        this.dialogRef.close();
                        this.exit();
                    }
                },
                (err) => {
                    this.alertService.error(
                        'Неверно указан действующий пароль.'
                    );
                    this.dialogRef.close();
                    this.loading = false;
                }
            );
        }
    }

    goToRecovery() {
        this.auth.logout();
        // localStorage.removeItem('sessionTokenAuthAriadna');
        // document.cookie = 'pa-web_Patient=;';
        this.router.navigate(['/login/recovery']);
    }
    maskPassword(event: Event, field: string): void {
        const input = event.target as HTMLInputElement;
        const value = input.value;
        const formControl = this.frm.get(field);

        if (formControl) {
            // Store the actual value in the form control
            formControl.setValue(value);

            // Mask the displayed value with '*' when the password is hidden
            if (
                (field === 'oldPW' && this.hidePasswordOLD) ||
                (field === 'newPW' && this.hidePasswordNEW) ||
                (field === 'new2PW' && this.hidePasswordNEW2)
            ) {
                input.value = '*'.repeat(value.length);
            } else {
                input.value = value; // Show actual value when visible
            }
        }
    }

    onBlur(field: string): void {
        const control = this.frm.get(field);
        if (control) {
            control.markAsTouched(); // Устанавливает статус "touched"
            control.updateValueAndValidity(); // Обновляет валидацию
        }
    }

    getErrorMessage(field: string): string {
        const control = this.frm.get(field);
        if (!control) return '';

        if (field === 'new2PW' && control.hasError('mismatch')) {
            return 'Пароли не совпадают';
        }

        if (control.hasError('required')) {
            return 'Это поле обязательно для заполнения';
        }
        if (control.hasError('minlength')) {
            return 'Пароль должен быть не менее 2 символов';
        }

        return '';
    }
}
